<template>
  <v-sheet class="programa-hero" rounded elevation="2">
    <div>
      <p class="hero-kicker">Ficha del programa</p>
      <h2 class="hero-title-text">{{ programa.nombre_compuesto || 'Nuevo programa' }}</h2>
      <p class="hero-subtitle" v-if="programa.programa_id">
        ID {{ programa.programa_id }} · Versión {{ programa.version || '-' }} · Grupo {{ programa.grupo || '-' }}
      </p>
    </div>
    <div class="hero-chips">
      <v-chip v-if="programa.estado" small label color="deep-purple accent-4" dark>{{ programa.estado }}</v-chip>
      <v-chip v-if="programa.gestion" small outlined color="white">Gestión {{ programa.gestion }}</v-chip>
      <v-chip v-if="programa.sede_id" small outlined color="white">Sede {{ programa.sede_id }}</v-chip>
      <v-btn small color="success" :loading="loading" :disabled="loading" outlined @click="$emit('guardar')">
        Guardar cambios
      </v-btn>
    </div>
  </v-sheet>
</template>

<script>
export default {
  name: 'ProgramaHero',
  props: {
    programa: { type: Object, required: true },
    loading: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.programa-hero {
  display: flex; align-items: center; justify-content: space-between;
  padding: 18px 22px; margin: 12px 0 18px;
  background: linear-gradient(135deg, #1e88e5 0%, #5e35b1 100%);
  color: #fff;
}
.hero-kicker { margin: 0 0 4px; font-size: 13px; text-transform: uppercase; letter-spacing: 0.08em; opacity: 0.85; }
.hero-title-text { margin: 0; font-weight: 700; color: #fff; }
.hero-subtitle { margin: 4px 0 0; opacity: 0.9; }
.hero-chips { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
</style>
